import {mergeSlice, resourceAdd, resourceInfo, resourceType, sliceUpload} from "@/utils/apis";
import Upload from "@/utils/slice_upload";

export default {
	name: "EditResourceDialog",
	props: ['id', 'dialogStatus'],
	data() {
		return {
			editingRow: null,
			downloadFile: '',
			previewFile: '',
			exts: ['doc','docx','ppt','pptx','xls','xlsx'],
			rules: {
				title: [
					{ required: true, message: '请输入资源标题', trigger: 'blur' }
				],
				intro: [
					{ required: true, message: '请输入简介', trigger: 'blur' }
				],
				path: [
					{ required: true, message: '请选择文件', trigger: 'change' }
				],
				type: [
					{ type: 'array', required: true, message: '请选择资源类型', trigger: 'change' },
				],
			},
			acceptFormat: '.pptx, .doc, .docx, .pdf, .mp4',
			resourceType: [],
			//资源类型
			resTypeProp: {
				label: 'name',
				value: 'id',
				children: 'children'
			},
			uploadPdf: null,
			uploadInstance: null,
			percent: 0,
			process: 0,
			chunkSize: 5*1024*1024,
		}
	},
	created() {
		this.resourceDetail();
		this.getResourcesType();
	},
	methods: {
		getResourcesType() {
			resourceType().then((res) => {
				this.resourceType = [...res.data];
			}, (err) => {
				console.log(err);
			})
		},
		closeDialog() {
			this.$emit('closeDialog', false);
		},
		notPdf(file_ext) {
			if (this.exts.indexOf(file_ext) !== -1) {
				this.addRules();
				return true;
			}
			return false
		},
		download() {
			window.open(`${this.editingRow.path}`);
		},
		preview() {
			if (this.exts.concat(['pdf']).indexOf(this.editingRow.file_ext) !== -1) {
				window.open(`${localStorage.getItem('hosturl')}pdf/${this.editingRow.id}`);
				return;
			}
			window.open(`${this.editingRow.preview_path}`);
		},
		resourceDetail() {
			resourceInfo(this.id).then(res => {
				if (res.code === 200) {
					this.editingRow = {
						category_id: res.data.category_id,
						title: res.data.title,
						intro: res.data.intro,
						id: res.data.id,
						path: res.data.path,
						preview_path: res.data.preview_path,
						file_ext: res.data.file_ext,
						type: res.data.resource_type_id,
						page_time: res.data.page_time,
					};
					this.downloadFile = `${this.editingRow.title}.${this.editingRow.file_ext}`;
					this.previewFile = `${this.editingRow.title}.pdf`;
					this.changeResourceType();
				}
			})
		},
		changeFile(event) {
			let file = event.target.files[0];
			this.downloadFile = file.name;
			this.editingRow.file_ext = this.getFileExt(file.name);
			this.editingRow.preview_path = '';
			this.previewFile = '';
			this.percent = 0;
			this.uploadInstance = new Upload(file, this.chunkSize, sliceUpload);
			this.uploadBlock(0);
			this.$refs.fileInstance.value='';
		},
		changeFilePdf(evt) {
			let file = evt.target.files[0];
			this.previewFile = file.name;
			this.uploadPdf = new Upload(file, this.chunkSize, sliceUpload);
			this.uploadBlock(0, 'pdf');
			this.$refs.pdfFile.value = '';
		},
		addRules() {
			this.rules.preview_path = [
				{ required: true, message: '请上传pdf格式的文件', trigger: 'change' }
			];
		},
		uploadBlock(index, alias='') {
			let total_block_num  =  alias === 'pdf' ? this.uploadPdf.total_block_num : this.uploadInstance.total_block_num;
			if (index === total_block_num && total_block_num !== 1) {
				//合并分片
				this.mergeSlice(alias);
				return;
			}
			let instance = alias === 'pdf' ? this.uploadPdf : this.uploadInstance;
			instance.uploadSlice(index).then(res => {
				if (res.code !== 200) {
					this.$message.warning(res.msg);
					return;
				}
				if (res.data.is_slice) {
					if (alias === 'pdf') {
						this.percent = Math.round((index/total_block_num) *100);
					} else {
						this.process = Math.round((index/total_block_num)*100);
					}
					this.uploadBlock(++index, alias);
				} else {
					if (alias === 'pdf') {
						this.percent = 100;
						this.editingRow.preview_path = res.data.src;
					} else {
						this.process = 100;
						this.editingRow.path = res.data.src;
					}
				}
			});
		},
		mergeSlice(alias='') {
			let param = {};
			if (alias === 'pdf') {
				param.flag = this.uploadPdf.file_tmp;
				param.slice_size = this.uploadPdf.block_size;
			} else {
				param.flag = this.uploadInstance.file_tmp;
				param.slice_size = this.uploadInstance.block_size;
			}
			mergeSlice(param).then(res => {
				if (res.code === 200) {
					if (alias === 'pdf') {
						this.percent = 100;
						this.editingRow.preview_path = res.data.src;
						return;
					}
					this.process = 100;
					this.editingRow.path = res.data.src;
				}
			});

		},
		getFileExt(filename) {
			let tmp = [];
			[...tmp] = filename.split('.');
			return tmp[tmp.length - 1];
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.editingRow.resource_type_id = this.editingRow.type[this.editingRow.type.length - 1];
					this.editingRow.file_ext = this.editingRow.file_ext.toLowerCase();
					if (this.exts.indexOf(this.editingRow.file_ext.toLowerCase()) === -1) {
						this.editingRow.preview_path = this.editingRow.path;
					}
					resourceAdd(this.editingRow).then(res => {
						if (res.code === 200) {
							this.$message({
								message: res.msg,
								type: "success",
								duration: 1500,
								onClose: () => {
									this.closeDialog();
									this.$emit('refresh', true);
								}
							});
						}
					})
				} else {
					return false;
				}
			})
		},
		resetEdit() {
			this.editingRow = null;
			this.uploadInstance = null;
			this.uploadPdf = null;
			this.percent = this.process = 0;
		},
		changeResourceType(val) {
			if (this.editingRow.type.length === 0 ) {
				this.acceptFormat = '.pptx, .doc, .docx, .pdf, .mp4';
				return;
			}
			let type = Number(this.editingRow.type[this.editingRow.type.length - 1]);
			switch (type) {
				case 1:
				case 6:
				case 8:
					// this.supportTypeDesc = '*支持上传资源格式：pptx/ppt/pdf';
					this.acceptFormat = '.pptx, .ppt, .pdf';
					break;
				case 2:
				case 10:
					// this.supportTypeDesc = '*支持上传资源格式：doc/docx/pdf';
					this.acceptFormat = '.doc, .docx, .pdf';
					break;
				case 3:
					// this.supportTypeDesc = '*支持上传资源格式：mp4';
					this.acceptFormat = '.mp4';
					break;
				case 4:
				case 9:
					// this.supportTypeDesc = '*支持上传资源格式：mp4';
					this.acceptFormat = '.mp4';
					break;
				case 5:
				case 7:
					// this.supportTypeDesc = '*支持上传资源格式：doc/docx/pdf/mp4/rar/zip';
					this.acceptFormat = '.doc, .docx, .pdf, .mp4, .rar, .zip';
					break;
			}
		},
	}

}